module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "intro"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "H1"
  }, [_vm._v("INTRODUCTION")]), _vm._v(" "), _c('p', {
    staticClass: "sp1"
  }), _vm._v(" "), _c('p', {
    staticClass: "TNI"
  }, [_vm._v("There’s a frontier waiting for you, approximately one hundred miles from where you are at this instant.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("It’s the frontier of space, and it extends to infinity.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("But space is only one of the many new frontiers that await us. There are frontiers of time, as well, and frontiers of courage and devotion, fear and hate.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Here are fourteen stories about new frontiers of space, time, and the human spirit.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The stories range from the Baghdad of the "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Thousand and One Nights")]), _vm._v(" to a spaceship heading for a distant star, from the newly liberated Paris near the end of World War II to a lonely vessel drifting in the vast emptiness of the Asteroid Belt. The stories are set on a golf course on the Moon, in the imperial court of an interstellar empire, in the simulations laboratory of a modern high-tech electronics firm.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The people in these stories include scoundrels and heroes, scientists and engineers, explorers and innovators, a teenaged Albert Einstein, a dying emperor, and a pope. Each of them stands at a new frontier and must find the heart and strength to cross into new, unexplored territory.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("For human courage and passion are the common denominators of every story, no matter where or when in the universe the tale may be set.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("So please enjoy your travels through these new frontiers of space, time, and the intricacies of human passions.")]), _vm._v(" "), _c('p', {
    staticClass: "TXS"
  }, [_vm._v("Bon voyage.")]), _vm._v(" "), _c('p', {
    staticClass: "AUSIG"
  }, [_vm._v("Ben Bova")]), _vm._v(" "), _c('p', {
    staticClass: "AUSIG"
  }, [_vm._v("Naples, Florida")]), _vm._v(" "), _c('p', {
    staticClass: "AUSIG"
  }, [_vm._v("2013")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-257f09c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/introduction.vue
// module id = 69
// module chunks = 0